var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumUpBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.9272 12.824C38.525 12.3134 38.0303 11.9046 37.4762 11.6246C36.922 11.3446 36.321 11.1999 35.713 11.2H25.7134V8C25.7134 5.87827 24.9609 3.84344 23.6214 2.34315C22.2819 0.842855 20.4651 4.10205e-07 18.5708 4.10205e-07C18.3054 -0.000212401 18.0452 0.0823823 17.8194 0.238523C17.5935 0.394664 17.411 0.618177 17.2923 0.884L10.5461 16H2.85704C2.09931 16 1.37261 16.3371 0.836808 16.9373C0.301009 17.5374 0 18.3513 0 19.2V36.8C0 37.6487 0.301009 38.4626 0.836808 39.0627C1.37261 39.6629 2.09931 40 2.85704 40H33.5703C34.6143 40.0004 35.6226 39.5739 36.4058 38.8005C37.189 38.0272 37.6932 36.9602 37.8237 35.8L39.9665 16.6C40.0424 15.924 39.989 15.2377 39.8098 14.5867C39.6306 13.9356 39.3298 13.3347 38.9272 12.824ZM2.85704 19.2H9.99965V36.8H2.85704V19.2Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumUpBlue);
export default __webpack_public_path__ + "static/media/thum-up-blue.470516a6792e22dc1441356d1e021119.svg";
export { ForwardRef as ReactComponent };